import { useDispatch } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { AppDispatch } from '../store';

export const useAppDispatch = <S, E, A extends Action>() => useDispatch<ThunkDispatch<S, E, A>>();
